<section class="w-full">

    @if(view.site?.id != 79) {
        <app-banner_section-type01 [options]="{ title: '', imageHref:view.imageLayer1 }"></app-banner_section-type01>
    }

    @if(view.page && view.site?.id === 79) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[600px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-bottom transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-bottom transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />

        <!-- Flowing wave SVG cut -->
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
            <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
        </svg>
    </div>
    }

    <!-- Features Section -->
     @if(view.site) {
         <app-change-game-type01 title="Corporate Travel" heading="" [features]="view.features"></app-change-game-type01>
     }

    <!-- <app-scroller_section-type01></app-scroller_section-type01> -->

    <!-- Intro section -->
    <div class="w-full  mx-auto">
        <div class="w-full mx-auto sm:px-6 grid gap-y-8 lg:gap-x-8 lg:gap-y-16" [ngClass]="{
      'md:grid-cols-1 pb-10': view.site?.id === 79,
      'md:grid-cols-2 py-8': view.site?.id !== 79
    }">
            <div>
                <div class="rounded-3xl">
                    <div class="flex flex-col">
                        @if (view.site && view.site.profile && view.site.profile.heading) {
                        @switch (view.site.profile.heading.banner) {
                        @case (1) {
                        <app-heading_section-type01
                            [options]="{heading:view.page?.content.name,title:'Transform Your Corporate Travel Experience',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                        }
                        @case (2) {
                        <app-heading_section-type01
                            [options]="{heading:'',title:'Transform Your Corporate Travel Experience',image:'', description:''}"></app-heading_section-type01>
                        }
                        }
                        }
                    </div>
                </div>
                <div class="flex justify-center">
                    <p class="max-w-4xl pt-10 px-4 text-center" [innerHTML]="view.page?.content.rawContent"></p>
                    <!-- <p class="px-4 text-gray-500" >Our customizable corporate travel programs align seamlessly with your company's requirements, ensuring duty of care and effective risk management through automated travel advisories and alerts. We focus on delivering an exceptional client experience, guiding you from the initial requisition to post-travel support. Our fast-acting systems identify out-of-policy behavior swiftly, while our partnership with Egencia enhances global travel management. With industry-leading technology, we maximize returns by serving our customers' needs effectively. Monitoring travel performance is made easy with email alerts, scheduled reporting, and dynamic insights. Experience unmatched customer care from dedicated consultants who prioritize your travel success in a competitive marketplace. Enjoy exceptional savings on hotels, cars, and airfare.</p> -->
                </div>
            </div>
            @if(view.site?.id != 79) {
            <div class=" w-[100%] ">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/72Q9wIOWFrM"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen>
                </iframe>
            </div>
            }
        </div>
    </div>

    <!-- How can we help you today section -->
    <!-- <section id="" class="relative bg-primary-500 py-10 sm:py-16">
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="max-w-2xl mx-auto text-center">
                <h2 class="text-4xl font-extrabold mx-auto md:text-6xl lg:text-5xl">How does it work?</h2>
                <p class="max-w-2xl mx-auto mt-4 text-base text-white leading-relaxed md:text-2xl">
                    Our travel solutions will help you from start to finish.
                </p>
            </div>
            <div class="relative mt-12 lg:mt-20">
                <div class="absolute inset-x-0 hidden xl:px-44 top-2 md:block md:px-20 lg:px-28"><img alt=""
                        loading="lazy" width="1000" height="500" decoding="async" data-nimg="1" class="w-full"
                        style="color:transparent"
                        src="https://cdn.rareblocks.xyz/collection/celebration/images/steps/2/curved-dotted-line.svg">
                </div>
                <div class="relative grid grid-cols-1 text-center gap-y-12 md:grid-cols-3 gap-x-12">
                    <div>
                        <div
                            class="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                            <span class="text-xl font-semibold text-gray-700">1</span>
                        </div>
                        <h3 class="mt-6 text-xl  text-white font-semibold leading-tight md:mt-10">Select solution
                        </h3>
                        <p class="mt-4 text-base text-white md:text-lg">
                            Select a solution according to your requirements.
                        </p>
                    </div>
                    <div>
                        <div
                            class="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                            <span class="text-xl font-semibold text-gray-700">2</span>
                        </div>
                        <h3 class="mt-6 text-xl text-white font-semibold leading-tight md:mt-10">Enter Your Details
                        </h3>
                        <p class="mt-4 text-base text-white md:text-lg">
                            Put in your personalized details and let we do the rest.
                        </p>
                    </div>
                    <div>
                        <div
                            class="flex items-center justify-center w-16 h-16 mx-auto bg-white border-2 border-gray-200 rounded-full shadow">
                            <span class="text-xl font-semibold text-gray-700">3</span>
                        </div>
                        <h3 class="mt-6 text-xl text-white font-semibold leading-tight md:mt-10">Let the solutions
                            thrive</h3>
                        <p class="mt-4 text-base text-white md:text-lg">
                            Sit back and watch as our solutions lets your thrive.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute inset-0 m-auto max-w-xs h-[357px] blur-[118px] sm:max-w-md md:max-w-lg"
            style="background:radial-gradient(1.89deg, rgba(34, 78, 95, 0.4) -1000%, rgba(191, 227, 205, 0.26) 1500.74%, rgba(34, 140, 165, 0.41) 56.49%, rgba(28, 47, 99, 0.11) 1150.91%)">
        </div>
    </section> -->

    <!-- <div class="p-4 md:p-8 lg:p-12 xl:p-16">
        <app-counters-type01></app-counters-type01>
    </div> -->

    <!-- Frequently Asked Questions -->
    <!-- <section class="py-10 sm:py-8">
        <div class="max-w-2xl mx-auto text-center">
            <h2 class="text-4xl font-extrabold mx-auto md:text-6xl lg:text-5xl">Frequently Asked <span
                    class="text-primary-500 text-5xl tracking-wide">Questions</span></h2>
        </div>
        <div class="bg-white border border-gray-200 divide-y divide-gray-200 rounded-xl m-8 sm:m-12">
            <details class="p-6 group" open>
                <summary class="flex items-center justify-between cursor-pointer">
                    <h5 class="text-lg font-medium text-gray-900">
                        1. Do I earn commission and if so, where can I find this amount?
                    </h5>
                    <span class="relative flex-shrink-0 ml-1.5 w-5 h-5">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                </summary>

                <p class="mt-4 leading-relaxed text-gray-700">
                    Yes, 10% commission is given based on land only. You can view the commissionable amount on the
                    review screen of your quotation/booking.
                </p>
            </details>

            <details class="p-6 group">
                <summary class="flex items-center justify-between cursor-pointer">
                    <h5 class="text-lg font-medium text-gray-900">
                        2. Can I adjust my pricing?
                    </h5>

                    <span class="relative flex-shrink-0 ml-1.5 w-5 h-5">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                </summary>

                <p class="mt-4 leading-relaxed text-gray-700">
                    Pricing can be adjusted by clicking on the ‘Add fee/adjustment’ icon on the review screen . Here
                    you
                    can add on service fees, or additional commission or apply a discount that you are offering to
                    your
                    client.
                </p>
            </details>

            <details class="p-6 group">
                <summary class="flex items-center justify-between cursor-pointer">
                    <h5 class="text-lg font-medium text-gray-900">
                        3. How do I reserve my booking?
                    </h5>

                    <span class="relative flex-shrink-0 ml-1.5 w-5 h-5">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                </summary>

                <p class="mt-4 leading-relaxed text-gray-700">
                    In the review screen, click on ‘Reserve’. Fill in all pax details and tick the T&C boxes. Once
                    all
                    boxes have been ticked, a ‘Reserve Now’ button will appear. By clicking on this button, your
                    booking
                    will be updated to a reserved status, and it will generate through on the Andgo.com agency’s
                    booking
                    queue. One of our agents will contact you advising that the booking has been received – once the
                    services have been confirmed by the suppliers, an invoice will be sent to you for payment.
                </p>
            </details>
            <details class="p-6 group">
                <summary class="flex items-center justify-between cursor-pointer">
                    <h5 class="text-lg font-medium text-gray-900">
                        4. How do I make payment?
                    </h5>

                    <span class="relative flex-shrink-0 ml-1.5 w-5 h-5">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-100 group-open:opacity-0" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg"
                            class="absolute inset-0 w-5 h-5 opacity-0 group-open:opacity-100" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                </summary>

                <p class="mt-4 leading-relaxed text-gray-700">
                    Payment can be made via EFT or credit card. Should you pay by credit card, a secure payment link
                    will be sent with the amount payable. Should you wish to pay the full amount (i.e. including the
                    commission), you can send us a commission invoice for the commission due to you once payment has
                    been processed.
                </p>
            </details>
        </div>
    </section> -->
</section>